import React from 'react';
import Signin from '../components/Signin';
import ScrollToTop from '../components/ScrollToTop';

const SigninPage = () => {
  return (
    <>
      <ScrollToTop />
      <Signin />
    </>
  );
};

export default SigninPage;